import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import Table from './DepartmentTable';
import Pagination from '../../CustomControls/Pagination';
import { getAllDepartments, setOnConfirmationModal, deleteDepartment } from '../../../store/actions/Master/department';
import LoadingSpinner from '../../CustomControls/Spinner';
import Notification from '../../CustomControls/Notification';
import Breadcrumbs from '../../CustomControls/Breadcrumb';
import { _create, _department, _delete } from '../../../constants/componentConstants';
import { hasPermissionToAction } from '../../../utils/accessUtil';
import SearchBar from '../../CustomControls/SearchBar';
import CustomConfirmation from '../../CustomControls/ConfirmationModal';

import './style.scss';

const Department = props => {
  const [searchText, setSearchText] = useState('');
  const [results, setResults] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const department = useSelector(state => state.department);
  const ui = useSelector(state => state.ui);
  const pageSize = ui.layout.pageSize;
  const permissions = ui.layout.permissions;

  const notificationType = department.isError ? 'error' : 'success';

  const showSaveOption = hasPermissionToAction(permissions, _department, _create);
  const showDeleteOption = hasPermissionToAction(permissions, _department, _delete);

  useEffect(() => {
    dispatch(getAllDepartments());
  }, [dispatch]);

  useEffect(() => {
    if (searchText.length > 0) {
      setResults(
        department.departmentList.filter(
          x =>
            x.departmentCode.toLowerCase().includes(searchText.toLowerCase()) ||
            x.departmentName.toLowerCase().includes(searchText.toLowerCase()) ||
            x.clientProfileName.toLowerCase().includes(searchText.toLowerCase()) ||
            x.costCenterName.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    } else {
      setResults(department.departmentList);
    }
  }, [searchText, setResults, department.departmentList]);

  const onPageChangeHandler = currentPage => {};

  const onAddNewHandler = () => {
    history.push('/master/departments/department');
  };

  const onEditHandler = id => {
    history.push(`/master/departments/department/${id}`);
  };

  const breadCrumbPaths = [
    { id: 1, title: 'Home', path: '/' },
    { id: 2, title: 'Department Listing', path: '/master/departments', isCurrent: true }
  ];

  const handleInput = e => {
    setSearchText(e.target.value);
  };

  const onDeleteHandler = id => {
    dispatch(
      setOnConfirmationModal({
        data: {
          showConfirmationModal: true,
          confirmationId: id
        }
      })
    );
  };

  const onDeleteConfirmation = () => {
    if (department.confirmationId) {
      dispatch(deleteDepartment(department.confirmationId));
    }
  };

  const onDeleteCancel = () => {
    dispatch(
      setOnConfirmationModal({
        data: {
          showConfirmationModal: false,
          confirmationId: ''
        }
      })
    );
  };

  return (
    <React.Fragment>
      <CustomConfirmation
        show={department.showConfirmationModal}
        onDeleteClick={onDeleteConfirmation}
        onCloseClick={onDeleteCancel}
        message="Are you sure you want to delete this record?"
        header="Deleting record"
      />
      <div className="page-content">
        {department.showMessage && <Notification notificationType={notificationType} message={department.message} />}
        <Container fluid>
          <Breadcrumbs title="Department Listing " paths={breadCrumbPaths} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row className="mb-2 buttonrow">
                    <Col sm="4">
                      <SearchBar onChange={handleInput} placeholder="Search" value={searchText} />
                    </Col>
                    <Col sm="8">
                      <div className="text-sm-end">
                        {showSaveOption && (
                          <Button type="button" className="btn btn-primary btn-block  app-add-button" onClick={onAddNewHandler}>
                            ADD DEPARTMENT
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="tablerow">
                    <Col xl="12">
                      <div>
                        {department.isLoading && <LoadingSpinner />}
                        <Pagination data={results} pageSize={pageSize} onPageChange={onPageChangeHandler} startingPage={1}>
                          <Table editHandler={onEditHandler} deleteHandler={onDeleteHandler} showDelete={showDeleteOption} />
                        </Pagination>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Department;
